import { getLeadStatusFromValue, Lead, PublicLead, isFollowedLead, getFollowerStatusValueToDisplay, FollowerStatus } from "shared/topchef.types"
import { useTranslation } from "react-i18next";

type LeadStatusProps = {
  lead: PublicLead | Lead
}

const LeadStatusDetails = ({ lead }: LeadStatusProps) => {
  const { t } = useTranslation();

  const currentLeadStatus = getLeadStatusFromValue(lead.status);
  let followerStatus: FollowerStatus = { value: '', label: '', css: ''};
  if (isFollowedLead(lead)){
    followerStatus = getFollowerStatusValueToDisplay(lead.followerStatus);
  }

  return (
    <>
      <span className={"brief-state rounded py-1 px-2 m-2 fw-bold "+ currentLeadStatus.css}>{t(currentLeadStatus.label)} </span>
      {isFollowedLead(lead) &&
        <>
          <span className={"brief-state rounded py-1 px-2 m-2 fw-bold "+ followerStatus.css} >{t(followerStatus.label)}</span>
        </>
      }
      
    </>
  );

}

export default LeadStatusDetails;
